import RecordTask from './RecordTask.vue'
export default RecordTask



// WEBPACK FOOTER //
// ./src/views/system/recordTask/index.js